export const ARCHIVE_SERVER_PATH = 'https://archive-server-dev.tattle.co.in';